import React, { useEffect, useRef, useState } from 'react'
import { I2cCheckbox } from "@webcomponents/i2cwebcomponents/dist/react";

const CheckboxRenderer = () => {

  const [checked, setChecked] = useState(false);

  const handleChange = (e) => {
    setChecked(e.target.checked);
    console.log('Checkbox checked:', e.target.checked);
  };

  return (
    <I2cCheckbox checked={checked} onI2cChange={handleChange} />
  );
};

export default CheckboxRenderer;
